<template>

  <button type="button" class="btn btn-sm btn-outline-info" data-bs-toggle="modal"
          data-bs-target="#modalProjectFileHistory" @click="openModal">
    <i class="bi bi-clock-history"></i>&nbsp; Historia zmian
  </button>

  <!-- Modal -->
  <div class="modal fade" id="modalProjectFileHistory" tabindex="-1" role="dialog" @click.self="closeModal"
       aria-labelledby="modelTitleId" aria-hidden="true" ref="modalHistory">
    <div class="modal-dialog modal-full-width" role="document">
      <div class="modal-content" ref="modalProjectFileHistoryContentRef">
        <div class="modal-header">
          <h5 class="modal-title">Ostatnie zmiany w zadaniach projektu</h5>
          <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body table-responsive text-start">

          <div class="row mt-3">
            <div class="col-sm-12">

              <div v-if="isLoading">
                <div class="position-absolute w-100 h-100 text-center" style="z-index: 9">
                  <div class="spinner-border text-danger me-2 align-self-center loader-lg" style="top:20%"></div>
                </div>
              </div>

              <div :style="{ opacity: isLoading ? '0.4' : '1' }">
                <ejs-grid id="GridProjectTasksHistory" ref="gridProjectTaskHistory"
                          gridLines="Both"
                          height='100%'
                          :allowExcelExport='true'
                          :dataSource="projectTaskHistoryData"
                          :allowPaging="true"
                          :allowFiltering="true"
                          :filterSettings="filterOptions"
                          :allowSorting="true"
                          :sortSettings="sortSettings"
                          :pageSettings='pageSettings'
                          :allowReordering='true'
                          :allowResizing='true'
                          :allowTextWrap="true"
                          :toolbar='toolbar'
                          :rowDataBound="onRowDataBound"
                          :toolbarClick="toolbarClick">
                  <e-columns>
                    <e-column field="original_id" headerText="ID" type="number" width="120"></e-column>
                    <e-column field="arrangement_id" headerText="ustalenie ID" type="number" width="160"></e-column>

                    <e-column field="team" headerText="Zespół" type="string" width="140"></e-column>
                    <e-column field="task" headerText="Zadanie" type="string"></e-column>
                    <e-column field="person_email" headerText="Osoba" type="string" width="220"></e-column>

                    <e-column field="date" headerText="Data" type="date" format="dd.MM.yyyy" width="130"></e-column>
                    <e-column field="comments" headerText="Uwagi" type="string"></e-column>
                    <e-column field="status" headerText="Status" type="string" width="140"></e-column>
                    <e-column field="after_receipt" headerText="Po odbiorze" type="boolean" width="130"></e-column>

                    <e-column field='created_by_name' headerText='Stworzył'></e-column>
                    <e-column field='updated_by_name' headerText='Aktualizował'></e-column>
                    <e-column field="updated_at" headerText="Data aktualizacji" type="date" format="dd.MM.yyyy HH:mm"
                              width="170"></e-column>
                    <e-column field="deleted_at" headerText="Data usunięcia" type="date" format="dd.MM.yyyy HH:mm"
                              width="170"></e-column>
                  </e-columns>
                </ejs-grid>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  Edit, ExcelExport,
  Filter,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Sort,
  Toolbar
} from '@syncfusion/ej2-vue-grids';

import GraphProjectFileProgress from "../../../Components/Widgets/Graphs/GraphProjectFileProgress.vue";

export default {
  components: {
    GraphProjectFileProgress,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },

  props: {
    projectId: Number,
  },

  data() {
    return {
      isOpened: false,
      isLoading: false,
      projectTaskHistoryData: {},
      filterOptions: {type: "Excel"},
      sortSettings: {columns: [{field: 'updated_at', direction: 'Descending'}]},
      pageSettings: {pageSize: 50, pageCount: 5, pageSizes: [10, 20, 50, 100, 200]},
      toolbar: [
        {text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right'},
        {text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right'},
      ]
    }
  },

  watch: {
    isOpened(newVal) {
      if (newVal === true) {
        this.getHistoryData();
      }
    }
  },

  provide:
      {
        grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport]
      },

  methods: {
    async getHistoryData() {
      this.isLoading = true;
      try {
        const response = await axios.post(route('projects.project-history.getHistoryForTasks', {project: this.projectId}));
        this.projectTaskHistoryData = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    onRowDataBound(args) {
      if (args.data.deleted_at) {
        args.row.classList.add('soft-deleted-row');
      }
    },

    toolbarClick(args) {
      if (args.item.id === 'restore') {
        let grid = this.$refs.gridProjectTaskHistory;
        let gridName = 'grid' + grid.$el.id;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
        location.reload();
      }

      if (args.item.id === 'excelexport') {
        this.$refs.gridProjectTaskHistory.excelExport({
          fileName: `${this.project.number}-plik projektu.xlsx`
        });
      }
    },

    openModal() {
      this.isOpened = true;

      const modalEl = this.$refs.modalHistory;
      modalEl.addEventListener('hide.bs.modal', () => {
        this.isOpened = false;
      }, {once: true});
    },

    closeModal() {
      this.projectTaskHistoryData = {};
      this.isOpened = false;
    }
  }
}
</script>

<style scoped>
:deep(.soft-deleted-row) {
  text-decoration: line-through;
  opacity: 0.8;
}
</style>